import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { usePrefs } from "@/lib/context";
import { CAT_TR } from "@/lib/i18n_extra";

export const catName = (c, lang) => c[`name_${lang}`] || CAT_TR[lang]?.[c.key] || (lang === "fr" ? c.name_fr : c.name_en || c.name_fr);

export const fetcher = (url) => api.get(url).then((r) => r.data);

export function useCategories() {
  const { lang } = usePrefs();
  const { data = [] } = useQuery({ queryKey: ["categories"], queryFn: () => fetcher("/categories") });
  const label = (key) => {
    const c = data.find((x) => x.key === key);
    return c ? catName(c, lang) : key;
  };
  return { property: data.filter((c) => c.type === "property"), trade: data.filter((c) => c.type === "trade"), all: data, label };
}

export function useTicketTitle() {
  const { fdatetime } = usePrefs();
  const { label } = useCategories();
  return (tk) => (tk.kind === "conciergerie" && tk.service ? `${label(tk.service)} — ${fdatetime(tk.scheduled_at)}` : tk.title);
}

export function useDirectory(role, enabled = true) {
  const { data = [] } = useQuery({ queryKey: ["directory", role], queryFn: () => fetcher(`/directory?role=${role}`), enabled });
  return data;
}

export function useMyProperties(enabled = true) {
  const { data = [] } = useQuery({ queryKey: ["properties"], queryFn: () => fetcher("/properties"), enabled });
  return data;
}

export async function downloadCsv(kind) {
  const r = await api.get(`/exports/${kind}`, { responseType: "blob" });
  const url = URL.createObjectURL(r.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = `gestimmo_${kind}.csv`;
  a.click();
  URL.revokeObjectURL(url);
}
